import { call, put, takeLatest , all} from 'redux-saga/effects'
import {
  addPatient,
  editPatient,
  getAllPatients,
  getAllPatientsReadings,
  showPatient,
  getSettings,
  editSettings,
  assignDevice,
  unAssignDevice,
  clearSelectedPatient
} from './patient.reducer'
import {updateAfterUnAssign} from '../device/device.reducer'
import Api from '../services/ApiCaller'
import { IPatient } from './patient.interface'
import { showErrorMessage, showMessage } from '../utils'
import {translate} from '../i18n'
import { goBack, push} from 'connected-react-router'

const successfulAdd = translate('patient.successMessages.patientAddSuccess')!
const successfulEdit = translate('patient.successMessages.patientEditSuccess')!

export function* addPatientRequest(api: Function, { payload }: any) {
  try {
    const { res = {} } = yield call(Api.callServer, api, payload , true)
    const { error, message } = res
    if (!error) {
      showMessage(successfulAdd)
      yield put(push('/patients'))
      yield put(addPatient.success(res))
      yield
    } else {
      yield put(addPatient.failure(message))
    }
  } catch (e) {
    yield put(addPatient.failure())
  }
}

function* getPatientByIdRequest(api: any, { payload }: any) {
  try {

    const [patientRes, settingsRes] = yield all([
      call(Api.callServer, api[0], payload),
      call(Api.callServer, api[1], payload)
    ])
    const { error, message } = patientRes
    if (!error) {
      showPatient.trigger({id: patientRes.id})
      yield put(showPatient.success({patient: patientRes.res, settings: settingsRes.res}))
    } else {
      showErrorMessage(message)
      yield put(showPatient.failure(message))
    }

  } catch (e) {

    yield put(showPatient.failure(e.message))
  }
}
function* editPatientRequest(api: Function, { payload }: any) {
  try {
    const { res = {} } = yield call(Api.callServer, api, payload, true)
    const { error, message } = res
    if (!error ) {
      showMessage(successfulEdit)
      yield put(editPatient.success(res))
    } else {
      yield put(editPatient.failure(message))
    }
  } catch (e) {
    yield put(editPatient.failure())
  }
}

export function* getAllPatientsRequest(api: Function, { payload }: any) {
  try {
    const { res = {} } = yield call(Api.callServer, api, payload, true)
    const { error, message } = res
    if (!error) {
      yield put(getAllPatients.success(res))
    } else {
      yield put(getAllPatients.failure(message))
    }
  } catch (e) {
    yield put(getAllPatients.failure(e.message))
  }
}
function* getAllPatientsReadingsRequest(api: Function, { payload }: any) {
  try {
    const { res = {} } = yield call(Api.callServer, api, payload, true)
    const { error, message } = res
    if (!error) {

      yield put(getAllPatientsReadings.success(res))
    } else {
      yield put(getAllPatientsReadings.failure(message))
    }
  } catch (e) {
    yield put(getAllPatientsReadings.failure(e.message))
  }
}

function* assignDeviceRequest(api: Function, { payload }: any) {
  try {
    const { res = {} } = yield call(Api.callServer, api, payload, true)
    const { error, message } = res
    if (!error) {
      showMessage(`${translate('patient.displayMessages.deviceAssignedSuccess')}`)
      yield put(assignDevice.success(res))
      yield put(goBack())
    } else {
      yield put(assignDevice.failure(message))
    }
  } catch (e) {
    yield put(assignDevice.failure(e.message))
  }
}

function* unAssignDeviceRequest(api: Function, { payload }: any) {
  try {
    const { res = {} } = yield call(Api.callServer, api, payload, true)
    const { error, message } = res
    if (!error) {
      showMessage(`${translate('patient.displayMessages.deviceUnAssignedSuccess')}`)
      yield put(unAssignDevice.success(res))
      yield(put(updateAfterUnAssign(res)))
    } else {
      showErrorMessage(message)
      yield put(unAssignDevice.failure(message))
    }
  } catch (e) {
    yield put(unAssignDevice.failure(e.message))
  }
}
export function* getSettingRequest(api: Function, { payload }: any) {
  try {
    const { res = {} } = yield call(Api.callServer, api, payload, true)
    const { error, message } = res
    if (!error) {
      yield put(getSettings.success(res))
    } else {
      yield put(getSettings.failure(message))
    }
  } catch (e) {
    yield put(getSettings.failure(e.message))
  }
}

function* editSettingsRequest(api: Function, { payload }: any) {
  try {
    const { res = {} } = yield call(Api.callServer, api, payload, true)
    const { error, message } = res
    if (!error) {
      yield put(editSettings.success(Object.assign(res, {careManagerId: payload.data.careManagerId})))
      showMessage(`${translate('patientSettings.messages.successfulEdit')}`)
    } else {
      yield put(editSettings.failure(message))
    }
  } catch (e) {
    yield put(editSettings.failure(e.message))
  }
}

function * clearSelectedPatientRequest(){
  yield put (clearSelectedPatient.success())

}

interface IidData {
  id: number
}

export default (api: any) => {
  const addPatientApi = (data: IPatient[]) => api.post('/patients', data)
  const editPatientApi = (data: IidData) => api.put(`/patients/${data.id}`, data)
  const getAllPatientsApi = (data: any) => api.get('/patients', data)
  const getAllPatientsReadingsApi = (data: any) => api.get('/patients/readings', data)
  const assignDeviceApi = (data: any) => api.put(`/patients/${data.patientId}/assign-device/${data.id}`)
  const unAssignDeviceApi = (data: any) => api.put(`/patients/${data.patientId}/unassign-device/`)
  const getPatientByIdApi = (data: any) => api.get(`/patients/${data.id}`, data)
  const getSettingsApi = (data: any) => api.get(`/patients-settings/${data.id}`, data)
  const editSettingsApi = (data: any) =>  api.put(`/patients-settings/${data.patientId}/${data.id}`, data.data)
  return [
    takeLatest(addPatient.TRIGGER, addPatientRequest, addPatientApi),
    takeLatest(showPatient.TRIGGER, getPatientByIdRequest, [getPatientByIdApi, getSettingsApi]),
    takeLatest(editPatient.TRIGGER, editPatientRequest, editPatientApi),
    takeLatest(
      getAllPatients.TRIGGER,
      getAllPatientsRequest,
      getAllPatientsApi
    ),
    takeLatest(
      getAllPatientsReadings.TRIGGER,
      getAllPatientsReadingsRequest,
      getAllPatientsReadingsApi
    ),
    takeLatest(editSettings.TRIGGER, editSettingsRequest, editSettingsApi),
    takeLatest(assignDevice.TRIGGER, assignDeviceRequest, assignDeviceApi),
    takeLatest(unAssignDevice.TRIGGER, unAssignDeviceRequest, unAssignDeviceApi),
    takeLatest(clearSelectedPatient.TRIGGER, clearSelectedPatientRequest)
  ]
}
